import { __read } from "tslib";
import { isFocusableHtmlElement } from '@office-start/dom-utility';
import { useEffect, useState } from 'react';
/**
 * Used to keep track of the last active element within a container
 * @param containerRef HTMLElement container where to search for active elements
 * @returns The active element or null
 */
export var useLastActiveHtmlElement = function (containerRef) {
    var _a = __read(useState(null), 2), lastActiveHtmlElement = _a[0], setLastActiveHtmlElement = _a[1];
    useEffect(function () {
        var onFocusIn = function () {
            if (isFocusableHtmlElement(document.activeElement) &&
                containerRef.current &&
                // If we've tabbed or already focused to the toast, don't set the last active element...
                !containerRef.current.contains(document.activeElement)) {
                setLastActiveHtmlElement(document.activeElement);
            }
        };
        document.addEventListener('focusin', onFocusIn);
        return function () {
            document.removeEventListener('focusin', onFocusIn);
        };
    }, [containerRef, setLastActiveHtmlElement]);
    return lastActiveHtmlElement;
};
//# sourceMappingURL=useLastActiveHtmlElement.js.map